/*
 * File: /src/router/routes/automations.js
 * Created Date: Sunday May 26th 2019
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Wednesday, 7th August 2019 11:00:22 am
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2019 AdBase, Inc.
 */

const AutomationList = () =>
  import(
    /* webpackChunkName: "Automations" */ 'src/components/Dashboard/Views/Automations/AutomationList.vue'
  );

const AutomationGallery = () =>
  import(
    /* webpackChunkName: "Automations" */ 'src/components/Dashboard/Views/Automations/AutomationGallery.vue'
  );

const AutomationEditor = () =>
  import(
    /* webpackChunkName: "Automations" */ 'src/components/Dashboard/Views/Automations/AutomationEditor.vue'
  );

export const automationRoutes = [
  {
    path: 'automations/list/:folderId?',
    name: 'All Automations',
    component: AutomationList,
    props: route => ({ initialId: parseInt(route.params.id)}),
  },
  {
    path: 'automations/gallery',
    name: 'Automation Gallery',
    component: AutomationGallery,
  },
  {
    path: 'automations/edit/:id?',
    name: 'Automation Editor',
    component: AutomationEditor,
    props: route => ({ initialId: parseInt(route.params.id)}),
  },
];
